import React from "react";

export default function MembersPageNav({numberOfProfiles, setSortOrderHandler, ...rest}) {
    return (
        <div {...rest} className="flex flew-row gap-4">
            <select className="bg-gray-700 text-white rounded" onChange={setSortOrderHandler}>
                <option value="null">Images First</option>
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
            </select>
            <span>{numberOfProfiles || 0} Members</span>
        </div>
    );
}